export const STR = {
  fr: {
    meta: {
      title: "GPN Sàrl — Carreleur à Fribourg | Carrelage & Rénovation · Villarsel-sur-Marly",
      description:
        "GPN Sàrl, entreprise de carrelage à Villarsel-sur-Marly : pose de carrelage, faïence, rénovation de salles de bains, grands formats, chapes, étanchéité et escaliers dans le canton de Fribourg et toute la Suisse romande. Devis gratuit et sans engagement.",
    },
    ctaDevis: "Demander un devis",
    nav: [
      { label: "Accueil", hash: "#accueil" },
      { label: "Prestations", hash: "#prestations" },
      { label: "Réalisations", hash: "#realisations" },
      { label: "À propos", hash: "#pourquoi" },
      { label: "Contact", hash: "#contact" },
    ],
    hero: {
      location: "Villarsel-sur-Marly · Canton de Fribourg",
      line2: "Carrelage & Rénovation",
      paragraph:
        "Votre spécialiste du carrelage et de la rénovation dans le canton de Fribourg. Nous accompagnons particuliers et professionnels dans leurs projets de construction et de rénovation, avec un travail précis, soigné et durable.",
      cta1: "Demander un devis",
      cta2: "Découvrir nos réalisations",
      trust: "Devis gratuit et sans engagement",
      pill2: "Particuliers & professionnels",
      pill3: "Grands formats & salles de bains",
      scrollAria: "Faire défiler vers les prestations",
      stats: [
        { value: "20+", label: "ans d'expérience" },
        { value: "300+", label: "projets réalisés" },
      ],
    },
    marquee: [
      "Carrelage grand format",
      "Salles de bains clé en main",
      "Faïence sur mesure",
      "Étanchéité certifiée",
      "Chapes & ragréages",
      "Escaliers en grès cérame",
      "Rénovation complète — Fribourg",
    ],
    prestations: {
      eyebrow: "Nos prestations",
      title: "Un savoir-faire complet, du support à la finition",
      subtitle:
        "Huit domaines d'expertise pour mener votre projet de A à Z, avec la précision et le soin qui font la réputation des artisans suisses.",
      cta: "Demander un devis gratuit",
      items: [
        { id: "carrelage", icon: "LayoutGrid", title: "Carrelage", tag: "Intérieur & extérieur", desc: "Pose de carrelage intérieur et extérieur. Sols, murs, cuisines, salles de bains et autres espaces." },
        { id: "faience", icon: "Grid2x2", title: "Faïence", tag: "Revêtements muraux", desc: "Pose de faïence et revêtements muraux avec des finitions précises et professionnelles." },
        { id: "salles-de-bains", icon: "Bath", title: "Salles de bains", tag: "Création & rénovation", desc: "Création et rénovation de salles de bains : pose de carrelage, faïence, étanchéité et finitions." },
        { id: "grands-formats", icon: "Expand", title: "Grands formats", tag: "Haut de gamme", desc: "Pose professionnelle de carreaux grand format pour des réalisations modernes et haut de gamme." },
        { id: "chapes", icon: "Layers", title: "Chapes & préparation", tag: "Supports", desc: "Préparation des supports, chapes, ragréages et travaux nécessaires avant la pose du revêtement." },
        { id: "etancheite", icon: "ShieldCheck", title: "Étanchéité", tag: "Zones humides", desc: "Travaux d'étanchéité pour salles de bains, douches et zones nécessitant une protection contre l'humidité." },
        { id: "escaliers", icon: "TrendingUp", title: "Escaliers", tag: "Sur mesure", desc: "Habillage et rénovation d'escaliers en carrelage avec finitions soignées." },
        { id: "renovation", icon: "Hammer", title: "Rénovation", tag: "Remise en état", desc: "Travaux de rénovation intérieure et remise en état de différents espaces." },
      ],
    },
    manifesto: {
      eyebrow: "Pourquoi GPN Sàrl ?",
      title: "La précision suisse, du support jusqu'aux dernières finitions",
      subtitle:
        "Chez GPN Sàrl, chaque projet est réalisé avec attention, de la préparation du support jusqu'aux dernières finitions. Notre objectif est de proposer une réalisation esthétique, solide et durable.",
      cta: "Discuter de votre projet",
      items: [
        { num: "01", title: "Travail soigné et précis", desc: "Calepinage millimétré et finitions irréprochables, de la première à la dernière pièce posée." },
        { num: "02", title: "Conseils personnalisés", desc: "Un accompagnement direct et honnête pour choisir les bons matériaux et la bonne mise en œuvre." },
        { num: "03", title: "Particuliers & professionnels", desc: "Des solutions adaptées aux particuliers, architectes, entreprises générales et régies." },
        { num: "04", title: "Respect des délais", desc: "Un planning d'intervention rigoureux, annoncé clairement et tenu sur le chantier." },
        { num: "05", title: "Matériaux & systèmes pro", desc: "Colles, joints et systèmes d'étanchéité professionnels pour un résultat solide et durable." },
        { num: "06", title: "Devis clair et détaillé", desc: "Un chiffrage transparent, poste par poste, sans surprise — gratuit et sans engagement." },
        { num: "07", title: "Entreprise locale", desc: "Une équipe fribourgeoise de proximité, joignable facilement avant, pendant et après le chantier." },
        { num: "08", title: "Canton de Fribourg & alentours", desc: "Intervention rapide dans tout le canton de Fribourg et dans toute la Suisse romande." },
      ],
    },
    realisations: {
      eyebrow: "Nos réalisations",
      title: "Des chantiers qui parlent d'eux-mêmes",
      subtitle:
        "Salles de bains, grands formats, escaliers, rénovations : une sélection de réalisations récentes dans le canton de Fribourg. Cliquez sur une photo pour l'agrandir.",
      categories: [
        { id: "all", label: "Toutes" },
        { id: "salles-de-bains", label: "Salles de bains" },
        { id: "carrelage", label: "Carrelage" },
        { id: "faience", label: "Faïence" },
        { id: "grands-formats", label: "Grands formats" },
        { id: "escaliers", label: "Escaliers" },
        { id: "renovations", label: "Rénovations" },
        { id: "chantiers", label: "Chantiers pro" },
      ],
      locSuffix: "Canton de Fribourg",
      prevAria: "Photo précédente",
      nextAria: "Photo suivante",
      closeAria: "Fermer",
      ba: {
        eyebrow: "Avant / Après",
        title: "Escalier en grès cérame — la transformation",
        desc: "Faites glisser le curseur : de l'escalier brut à la pose grand format. Chaque marche est préparée, calée et alignée au millimètre par nos soins.",
        before: "Avant",
        after: "Après",
      },
    },
    clients: {
      eyebrow: "Particuliers & professionnels",
      title: "Un interlocuteur fiable pour chaque type de projet",
      subtitle:
        "De la salle de bains familiale au chantier d'entreprise générale, GPN Sàrl adapte son organisation à vos exigences.",
      part: {
        title: "Particuliers",
        intro: "Votre projet de rénovation mérite une exécution impeccable et un suivi simple, sans mauvaise surprise.",
        bullets: [
          "Rénovation de salle de bains, de la dépose aux finitions",
          "Remplacement de carrelage : sols, murs et escaliers",
          "Conseils personnalisés et aide au choix des matériaux",
          "Protection soigneuse de vos espaces pendant les travaux",
        ],
        cta: "Lancer mon projet",
      },
      pro: {
        title: "Professionnels",
        intro: "Architectes, entreprises générales, régies et maîtres d'ouvrage : un partenaire carrelage réactif et rigoureux.",
        bullets: [
          "Collaboration avec architectes, entreprises générales et régies",
          "Réponse aux appels d'offres et soumissions détaillées",
          "Chantiers de construction et de rénovation, remises en état",
          "Respect des cahiers des charges, des délais et de la coordination",
        ],
        cta: "Soumettre un projet",
        note: "Appels d'offres & chantiers professionnels bienvenus",
      },
    },
    zone: {
      eyebrow: "Zone d'intervention",
      title: "Votre carreleur dans la région de Fribourg",
      subtitle:
        "GPN Sàrl est basée à Villarsel-sur-Marly et intervient dans tout le canton de Fribourg, ainsi que dans toute la Suisse romande.",
      cities: [
        "Fribourg", "Marly", "Bulle", "Châtel-Saint-Denis", "Belfaux",
        "Villarsel-sur-Marly", "Lausanne", "Toute la Suisse romande",
      ],
      badge1: "Intervention rapide",
      badge2: "Canton de Fribourg & toute la Suisse romande",
      imageAlt: "Catalogue d'échantillons de carrelage marbre et céramique proposé par GPN Sàrl à Fribourg",
    },
    devis: {
      eyebrow: "Demande de devis",
      title: "Vous avez un projet ? Parlons-en.",
      subtitle:
        "Construction, rénovation, salle de bains ou nouveau carrelage ? Contactez GPN Sàrl pour discuter de votre projet et recevoir une offre personnalisée.",
      labels: {
        nom: "Nom / Prénom *",
        entreprise: "Entreprise",
        optional: "(facultatif)",
        telephone: "Téléphone *",
        email: "E-mail *",
        localite: "Localité *",
        type: "Type de travaux *",
        message: "Message",
        files: "Photos ou plans",
        filesHint: "(JPG, PNG, PDF — 10 Mo max par fichier)",
      },
      placeholders: {
        nom: "Votre nom",
        entreprise: "Nom de l'entreprise",
        telephone: "078 000 00 00",
        email: "vous@exemple.ch",
        localite: "ex. 1700 Fribourg",
        select: "Sélectionnez…",
        message: "Décrivez votre projet : surface, état actuel, délais souhaités…",
      },
      types: [
        "Carrelage intérieur / extérieur",
        "Faïence",
        "Salle de bains (création ou rénovation)",
        "Carrelage grand format",
        "Chape / préparation du support",
        "Étanchéité",
        "Escaliers",
        "Rénovation intérieure",
        "Autre / je ne sais pas encore",
      ],
      dropzone: "Cliquez pour ajouter des photos ou plans de votre projet",
      submit: "Envoyer ma demande de devis",
      sending: "Envoi en cours…",
      privacy:
        "En envoyant ce formulaire, vous acceptez notre politique de confidentialité. Vos données servent uniquement à traiter votre demande.",
      toastOkTitle: "Demande de devis envoyée",
      toastOkDesc: "Merci ! GPN Sàrl revient vers vous rapidement avec une offre personnalisée.",
      toastErrTitle: "Envoi impossible",
      toastErrDesc: "Réessayez ou appelez-nous au 078 796 98 50.",
      fileTooBigTitle: "Fichier trop volumineux",
      fileTooBigSuffix: "dépasse 10 Mo.",
      contact: {
        title: "Contact direct",
        intro: "Une question, un chantier à planifier ? Appelez-nous ou écrivez-nous.",
        freeTitle: "Devis gratuit et sans engagement",
        freeText: "Visite sur place possible dans tout le canton de Fribourg pour un chiffrage précis.",
        hours: "Lun – Ven : 07h00 – 18h30 · Sam : sur rendez-vous",
      },
    },
    footer: {
      brand: "Entreprise suisse de carrelage et de rénovation. Travail précis, soigné et durable dans le canton de Fribourg.",
      navTitle: "Navigation",
      contactTitle: "Contact",
      infoTitle: "Informations",
      legal1: "Mentions légales",
      legal2: "Politique de confidentialité",
      zoneText:
        "Zone d'intervention : canton de Fribourg, Marly, Bulle, La Roche, Le Mouret, Villarsel-sur-Marly — et toute la Suisse romande (Lausanne, Genève, Neuchâtel, Vevey, Sion…).",
      rights: "© 2026 GPN Sàrl — Carrelage & Rénovation. Tous droits réservés.",
      tagline: "Villarsel-sur-Marly · Suisse",
      logoAlt: "GPN Sàrl — Carrelage & Rénovation",
    },
    fabCallPrefix: "Appeler le",
    legal: {
      back: "Retour à l'accueil",
      contactLabel: "Contact",
      mentions: {
        title: "Mentions légales",
        sections: [
          { h: "Éditeur du site", p: "GPN Sàrl — Carrelage & Rénovation, 1723 Villarsel-sur-Marly, Suisse. Téléphone : 078 796 98 50 / 078 738 93 50. E-mail : info@gpncarrelage.ch. Numéro IDE : communiqué sur demande." },
          { h: "Directeur de la publication", p: "La direction de GPN Sàrl, 1723 Villarsel-sur-Marly." },
          { h: "Hébergement", p: "Ce site est hébergé dans le cadre de la plateforme Emergent (emergent.sh). Les données sont traitées au sein d'infrastructures cloud sécurisées." },
          { h: "Propriété intellectuelle", p: "L'ensemble des contenus du site (logo, textes, photographies, mise en page) est la propriété de GPN Sàrl ou fait l'objet de droits d'utilisation. Toute reproduction, même partielle, est interdite sans autorisation écrite préalable." },
          { h: "Responsabilité", p: "GPN Sàrl s'efforce de fournir des informations exactes et à jour. Elle ne saurait toutefois être tenue responsable d'erreurs, d'omissions ou d'une indisponibilité temporaire du site. Les photographies de réalisations sont présentées à titre d'illustration du savoir-faire." },
          { h: "Droit applicable", p: "Le présent site est soumis au droit suisse. Tout litige relatif à son utilisation est de la compétence des tribunaux du canton de Fribourg." },
        ],
      },
      privacy: {
        title: "Politique de confidentialité",
        sections: [
          { h: "Responsable du traitement", p: "GPN Sàrl — Carrelage & Rénovation, 1723 Villarsel-sur-Marly, Suisse (info@gpncarrelage.ch), est responsable du traitement des données collectées via ce site, conformément à la Loi fédérale sur la protection des données (LPD)." },
          { h: "Données collectées", p: "Via le formulaire de demande de devis : nom et prénom, nom d'entreprise (facultatif), numéro de téléphone, adresse e-mail, localité, type de travaux, message, ainsi que les photos ou plans que vous nous transmettez volontairement." },
          { h: "Finalité du traitement", p: "Ces données servent exclusivement à traiter votre demande de devis, à vous recontacter et à préparer une offre personnalisée. Elles ne sont ni vendues, ni cédées à des tiers à des fins commerciales." },
          { h: "Conservation et sécurité", p: "Les demandes sont transmises par e-mail à l'entreprise et conservées le temps nécessaire au traitement de votre projet et aux obligations légales. Des mesures techniques et organisationnelles appropriées protègent vos données contre tout accès non autorisé." },
          { h: "Cookies", p: "Ce site n'utilise pas de cookies publicitaires ni de traceurs tiers à des fins marketing." },
          { h: "Vos droits", p: "Vous disposez d'un droit d'accès, de rectification et de suppression de vos données personnelles. Pour exercer ces droits, écrivez à info@gpncarrelage.ch ou appelez le 078 796 98 50." },
        ],
      },
    },
  },

  de: {
    meta: {
      title: "GPN Sàrl — Fliesenleger in Freiburg | Fliesen & Renovationen · Villarsel-sur-Marly",
      description:
        "GPN Sàrl, Fliesenunternehmen in Villarsel-sur-Marly: Fliesenverlegung, Wandfliesen, Badezimmer-Renovation, Grossformate, Estriche, Abdichtung und Treppen im Kanton Freiburg und in der ganzen Romandie. Kostenlose und unverbindliche Offerte.",
    },
    ctaDevis: "Offerte anfordern",
    nav: [
      { label: "Start", hash: "#accueil" },
      { label: "Leistungen", hash: "#prestations" },
      { label: "Referenzen", hash: "#realisations" },
      { label: "Über uns", hash: "#pourquoi" },
      { label: "Kontakt", hash: "#contact" },
    ],
    hero: {
      location: "Villarsel-sur-Marly · Kanton Freiburg",
      line2: "Fliesen & Renovationen",
      paragraph:
        "Ihr Spezialist für Fliesen und Renovationen im Kanton Freiburg. Wir begleiten Private und Profis bei ihren Bau- und Renovationsprojekten — mit präziser, sorgfältiger und langlebiger Arbeit.",
      cta1: "Offerte anfordern",
      cta2: "Unsere Referenzen entdecken",
      trust: "Kostenlose und unverbindliche Offerte",
      pill2: "Privat- & Geschäftskunden",
      pill3: "Grossformate & Badezimmer",
      scrollAria: "Zu den Leistungen scrollen",
      stats: [
        { value: "20+", label: "Jahre Erfahrung" },
        { value: "300+", label: "abgeschlossene Projekte" },
      ],
    },
    marquee: [
      "Grossformat-Fliesen",
      "Badezimmer schlüsselfertig",
      "Massgefertigte Wandfliesen",
      "Zertifizierte Abdichtung",
      "Estriche & Spachtelmassen",
      "Treppen aus Feinsteinzeug",
      "Komplette Renovation — Freiburg",
    ],
    prestations: {
      eyebrow: "Unsere Leistungen",
      title: "Umfassendes Know-how, vom Untergrund bis zum Finish",
      subtitle:
        "Acht Fachgebiete, um Ihr Projekt von A bis Z umzusetzen — mit der Präzision und Sorgfalt, für die Schweizer Handwerksbetriebe bekannt sind.",
      cta: "Kostenlose Offerte anfordern",
      items: [
        { id: "carrelage", icon: "LayoutGrid", title: "Fliesen", tag: "Innen & Aussen", desc: "Verlegung von Innen- und Aussenfliesen. Böden, Wände, Küchen, Badezimmer und weitere Räume." },
        { id: "faience", icon: "Grid2x2", title: "Wandfliesen", tag: "Wandverkleidungen", desc: "Verlegung von Wandfliesen und Wandverkleidungen mit präzisen, professionellen Abschlüssen." },
        { id: "salles-de-bains", icon: "Bath", title: "Badezimmer", tag: "Neubau & Renovation", desc: "Erstellung und Renovation von Badezimmern: Fliesen, Wandfliesen, Abdichtung und Abschlüsse." },
        { id: "grands-formats", icon: "Expand", title: "Grossformate", tag: "Hochwertig", desc: "Professionelle Verlegung von Grossformat-Fliesen für moderne, hochwertige Projekte." },
        { id: "chapes", icon: "Layers", title: "Estriche & Untergrund", tag: "Untergrund", desc: "Untergrundvorbereitung, Estriche, Spachtelmassen und alle Arbeiten vor der Belagsverlegung." },
        { id: "etancheite", icon: "ShieldCheck", title: "Abdichtung", tag: "Feuchträume", desc: "Abdichtungsarbeiten für Badezimmer, Duschen und Bereiche mit Bedarf an Feuchtigkeitsschutz." },
        { id: "escaliers", icon: "TrendingUp", title: "Treppen", tag: "Massgefertigt", desc: "Verkleidung und Renovation von Treppen mit Fliesen und sorgfältigen Abschlüssen." },
        { id: "renovation", icon: "Hammer", title: "Renovation", tag: "Instandstellung", desc: "Innenrenovationen und Instandstellung verschiedener Räume." },
      ],
    },
    manifesto: {
      eyebrow: "Warum GPN Sàrl?",
      title: "Schweizer Präzision, vom Untergrund bis zum letzten Finish",
      subtitle:
        "Bei GPN Sàrl wird jedes Projekt mit Sorgfalt ausgeführt, von der Untergrundvorbereitung bis zu den letzten Abschlüssen. Unser Ziel ist ein ästhetisches, solides und langlebiges Ergebnis.",
      cta: "Über Ihr Projekt sprechen",
      items: [
        { num: "01", title: "Sorgfältige, präzise Arbeit", desc: "Millimetergenaues Verlegebild und makellose Abschlüsse, von der ersten bis zur letzten verlegten Fliese." },
        { num: "02", title: "Persönliche Beratung", desc: "Direkte und ehrliche Begleitung bei der Wahl der richtigen Materialien und Verlegemethode." },
        { num: "03", title: "Privat & Geschäftskunden", desc: "Massgeschneiderte Lösungen für Private, Architekten, Generalunternehmen und Verwaltungen." },
        { num: "04", title: "Termineinhaltung", desc: "Ein strenger Einsatzplan, klar kommuniziert und auf der Baustelle eingehalten." },
        { num: "05", title: "Profi-Materialien & Systeme", desc: "Professionelle Kleber, Fugen und Abdichtungssysteme für ein solides, langlebiges Ergebnis." },
        { num: "06", title: "Klare, detaillierte Offerte", desc: "Transparente Kalkulation, Position für Position, ohne Überraschungen — kostenlos und unverbindlich." },
        { num: "07", title: "Lokales Unternehmen", desc: "Ein Team aus der Freiburger Region — vor, während und nach der Baustelle gut erreichbar." },
        { num: "08", title: "Kanton Freiburg & Umgebung", desc: "Schnelle Einsätze im ganzen Kanton Freiburg und in der ganzen Romandie." },
      ],
    },
    realisations: {
      eyebrow: "Unsere Referenzen",
      title: "Projekte, die für sich sprechen",
      subtitle:
        "Badezimmer, Grossformate, Treppen, Renovationen: eine Auswahl aktueller Projekte im Kanton Freiburg. Klicken Sie auf ein Foto, um es zu vergrössern.",
      categories: [
        { id: "all", label: "Alle" },
        { id: "salles-de-bains", label: "Badezimmer" },
        { id: "carrelage", label: "Fliesen" },
        { id: "faience", label: "Wandfliesen" },
        { id: "grands-formats", label: "Grossformate" },
        { id: "escaliers", label: "Treppen" },
        { id: "renovations", label: "Renovationen" },
        { id: "chantiers", label: "Profi-Baustellen" },
      ],
      locSuffix: "Kanton Freiburg",
      prevAria: "Vorheriges Foto",
      nextAria: "Nächstes Foto",
      closeAria: "Schliessen",
      ba: {
        eyebrow: "Vorher / Nachher",
        title: "Treppe in Feinsteinzeug — die Verwandlung",
        desc: "Ziehen Sie den Regler: von der rohen Treppe bis zur Grossformat-Verlegung. Jede Stufe wird von uns vorbereitet und millimetergenau ausgerichtet.",
        before: "Vorher",
        after: "Nachher",
      },
    },
    clients: {
      eyebrow: "Privat & Professionell",
      title: "Ein zuverlässiger Ansprechpartner für jedes Projekt",
      subtitle:
        "Vom familiären Badezimmer bis zur Baustelle des Generalunternehmens: GPN Sàrl passt seine Organisation Ihren Anforderungen an.",
      part: {
        title: "Privatpersonen",
        intro: "Ihr Renovationsprojekt verdient eine einwandfreie Ausführung und eine einfache Begleitung — ohne böse Überraschungen.",
        bullets: [
          "Badezimmer-Renovation, vom Rückbau bis zum Finish",
          "Ersatz von Fliesen: Böden, Wände und Treppen",
          "Persönliche Beratung und Hilfe bei der Materialwahl",
          "Sorgfältiger Schutz Ihrer Wohnräume während der Arbeiten",
        ],
        cta: "Mein Projekt starten",
      },
      pro: {
        title: "Profis",
        intro: "Architekten, Generalunternehmen, Verwaltungen und Bauherren: ein reaktiver und zuverlässiger Fliesenpartner.",
        bullets: [
          "Zusammenarbeit mit Architekten, Generalunternehmen und Verwaltungen",
          "Antworten auf Ausschreibungen und detaillierte Submissionen",
          "Neubau- und Renovationsbaustellen, Instandstellungen",
          "Einhaltung von Lastenheften, Terminen und Koordination",
        ],
        cta: "Projekt einreichen",
        note: "Ausschreibungen & Profi-Baustellen willkommen",
      },
    },
    zone: {
      eyebrow: "Einsatzgebiet",
      title: "Ihr Fliesenleger in der Region Freiburg",
      subtitle:
        "GPN Sàrl ist in Villarsel-sur-Marly ansässig und im ganzen Kanton Freiburg sowie in der ganzen Romandie im Einsatz.",
      cities: [
        "Freiburg", "Marly", "Bulle", "Châtel-Saint-Denis", "Belfaux",
        "Villarsel-sur-Marly", "Lausanne", "Ganze Romandie",
      ],
      badge1: "Schneller Einsatz",
      badge2: "Kanton Freiburg & ganze Romandie",
      imageAlt: "Katalog mit Marmor- und Keramikfliesenmustern von GPN Sàrl in Freiburg",
    },
    devis: {
      eyebrow: "Offertenanfrage",
      title: "Sie haben ein Projekt? Sprechen wir darüber.",
      subtitle:
        "Neubau, Renovation, Badezimmer oder neue Fliesen? Kontaktieren Sie GPN Sàrl, um Ihr Projekt zu besprechen und ein persönliches Angebot zu erhalten.",
      labels: {
        nom: "Name / Vorname *",
        entreprise: "Firma",
        optional: "(optional)",
        telephone: "Telefon *",
        email: "E-Mail *",
        localite: "Ort *",
        type: "Art der Arbeiten *",
        message: "Nachricht",
        files: "Fotos oder Pläne",
        filesHint: "(JPG, PNG, PDF — max. 10 MB pro Datei)",
      },
      placeholders: {
        nom: "Ihr Name",
        entreprise: "Name der Firma",
        telephone: "078 000 00 00",
        email: "sie@beispiel.ch",
        localite: "z. B. 1700 Freiburg",
        select: "Auswählen…",
        message: "Beschreiben Sie Ihr Projekt: Fläche, aktueller Zustand, gewünschte Termine…",
      },
      types: [
        "Innen- / Aussenfliesen",
        "Wandfliesen",
        "Badezimmer (Neubau oder Renovation)",
        "Grossformat-Fliesen",
        "Estrich / Untergrundvorbereitung",
        "Abdichtung",
        "Treppen",
        "Innenrenovation",
        "Andere / noch unsicher",
      ],
      dropzone: "Klicken Sie hier, um Fotos oder Pläne Ihres Projekts hinzuzufügen",
      submit: "Meine Offertenanfrage senden",
      sending: "Wird gesendet…",
      privacy:
        "Mit dem Absenden dieses Formulars akzeptieren Sie unsere Datenschutzerklärung. Ihre Daten dienen ausschliesslich der Bearbeitung Ihrer Anfrage.",
      toastOkTitle: "Offertenanfrage gesendet",
      toastOkDesc: "Vielen Dank! GPN Sàrl meldet sich rasch mit einem persönlichen Angebot bei Ihnen.",
      toastErrTitle: "Senden fehlgeschlagen",
      toastErrDesc: "Versuchen Sie es erneut oder rufen Sie uns an: 078 796 98 50.",
      fileTooBigTitle: "Datei zu gross",
      fileTooBigSuffix: "überschreitet 10 MB.",
      contact: {
        title: "Direkter Kontakt",
        intro: "Eine Frage, eine Baustelle zu planen? Rufen Sie uns an oder schreiben Sie uns.",
        freeTitle: "Kostenlose und unverbindliche Offerte",
        freeText: "Vor-Ort-Besuch im ganzen Kanton Freiburg möglich für eine präzise Kalkulation.",
        hours: "Mo – Fr: 07.00 – 18.30 Uhr · Sa: nach Vereinbarung",
      },
    },
    footer: {
      brand: "Schweizer Unternehmen für Fliesen und Renovationen. Präzise, sorgfältige und langlebige Arbeit im Kanton Freiburg.",
      navTitle: "Navigation",
      contactTitle: "Kontakt",
      infoTitle: "Rechtliches",
      legal1: "Impressum",
      legal2: "Datenschutzerklärung",
      zoneText:
        "Einsatzgebiet: Kanton Freiburg, Marly, Bulle, La Roche, Le Mouret, Villarsel-sur-Marly — sowie die ganze Romandie (Lausanne, Genf, Neuenburg, Vevey, Sitten…).",
      rights: "© 2026 GPN Sàrl — Fliesen & Renovationen. Alle Rechte vorbehalten.",
      tagline: "Villarsel-sur-Marly · Schweiz",
      logoAlt: "GPN Sàrl — Fliesen & Renovationen",
    },
    fabCallPrefix: "Anrufen:",
    legal: {
      back: "Zurück zur Startseite",
      contactLabel: "Kontakt",
      mentions: {
        title: "Impressum",
        sections: [
          { h: "Herausgeber der Website", p: "GPN Sàrl — Fliesen & Renovationen, 1723 Villarsel-sur-Marly, Schweiz. Telefon: 078 796 98 50 / 078 738 93 50. E-Mail: info@gpncarrelage.ch. UID-Nummer: auf Anfrage erhältlich." },
          { h: "Verantwortlich für den Inhalt", p: "Die Geschäftsführung der GPN Sàrl, 1723 Villarsel-sur-Marly." },
          { h: "Hosting", p: "Diese Website wird über die Plattform Emergent (emergent.sh) gehostet. Die Daten werden in sicheren Cloud-Infrastrukturen bearbeitet." },
          { h: "Geistiges Eigentum", p: "Sämtliche Inhalte der Website (Logo, Texte, Fotografien, Layout) sind Eigentum der GPN Sàrl oder werden mit Nutzungsrechten verwendet. Jede auch teilweise Vervielfältigung ist ohne vorherige schriftliche Genehmigung untersagt." },
          { h: "Haftung", p: "GPN Sàrl bemüht sich um genaue und aktuelle Informationen. Sie kann jedoch nicht für Fehler, Auslassungen oder eine vorübergehende Nichtverfügbarkeit der Website haftbar gemacht werden. Die Fotos der Referenzen dienen der Veranschaulichung des Fachkönnens." },
          { h: "Anwendbares Recht", p: "Diese Website unterliegt Schweizer Recht. Für alle Streitigkeiten im Zusammenhang mit ihrer Nutzung sind die Gerichte des Kantons Freiburg zuständig." },
        ],
      },
      privacy: {
        title: "Datenschutzerklärung",
        sections: [
          { h: "Verantwortliche Stelle", p: "GPN Sàrl — Fliesen & Renovationen, 1723 Villarsel-sur-Marly, Schweiz (info@gpncarrelage.ch), ist verantwortlich für die Bearbeitung der über diese Website gesammelten Daten, gemäss dem Schweizer Datenschutzgesetz (DSG)." },
          { h: "Erhobene Daten", p: "Über das Offertenformular: Vor- und Nachname, Firmenname (optional), Telefonnummer, E-Mail-Adresse, Ort, Art der Arbeiten, Nachricht sowie die Fotos oder Pläne, die Sie uns freiwillig übermitteln." },
          { h: "Zweck der Bearbeitung", p: "Diese Daten dienen ausschliesslich der Bearbeitung Ihrer Offertenanfrage, der erneuten Kontaktaufnahme und der Erstellung eines persönlichen Angebots. Sie werden weder verkauft noch zu kommerziellen Zwecken an Dritte weitergegeben." },
          { h: "Aufbewahrung und Sicherheit", p: "Die Anfragen werden per E-Mail an das Unternehmen übermittelt und so lange aufbewahrt, wie es für die Bearbeitung Ihres Projekts und gesetzliche Pflichten erforderlich ist. Geeignete technische und organisatorische Massnahmen schützen Ihre Daten vor unbefugtem Zugriff." },
          { h: "Cookies", p: "Diese Website verwendet keine Werbe-Cookies und keine Dritt-Tracker zu Marketingzwecken." },
          { h: "Ihre Rechte", p: "Sie haben das Recht auf Auskunft, Berichtigung und Löschung Ihrer Personendaten. Um diese Rechte auszuüben, schreiben Sie an info@gpncarrelage.ch oder rufen Sie 078 796 98 50 an." },
        ],
      },
    },
  },
};
